import { useMutation } from 'react-query';
import messages from './messages';
import { generateStandardFilename } from '@fortress-technology-solutions/fortress-component-library/utils';
import useIntl from '../../hooks/useIntl';
import { toastr } from 'react-redux-toastr';
import AffordableQualificationService from '../../services/affordableQualificationService';

const useDownloadCertificationMutation = ({ organizationId, propertyId }) => {
  const intl = useIntl();

  return useMutation(
    async ({ affordableQualificationId, use59A }) => {
      const filename = generateStandardFilename({
        type: use59A ? '50059A' : '50059',
        extension: 'pdf',
      });

      toastr.info(
        'Pending',
        intl.formatMessage(
          use59A ? messages.downloading50059a : messages.downloading50059,
        ),
      );
      return new AffordableQualificationService().generate59(
        organizationId,
        propertyId,
        affordableQualificationId,
        filename,
      );
    },
    {
      onError: (error) => {
        const msg =
          typeof error === 'string'
            ? error
            : error?.error ||
              error?.networkError ||
              error?.message ||
              intl.formatMessage(messages.downloading50059Error);
        toastr.error('Error', msg);
      },
    },
  );
};

export default useDownloadCertificationMutation;
